import { City, State } from "country-state-city";
import Button from "../../components/NewButton";
import "./Caracteristicas.css";
import { Col, Form, Row } from "react-bootstrap";
import { useState } from "react";

export default function Caracteristicas() {
  const [estadoCode, setEstadoCode] = useState("");
  function submitInfo() {}
  return (
    <>
      <div className="start">
        <Row style={{ marginTop: "20px" }}>
          <Col
            md={8}
            style={{
              alignSelf: "center",
              paddingRight: "30px",
              paddingLeft: "30px",
            }}
          >
            <h2 style={{ fontWeight: "bold", textAlign: "center" }}>
              BENEFICIOS PRINCIPALES
            </h2>
            <ul style={{ alignSelf: "flex-start" }}>
              <li className="list-element">
                <h4 className="titleText">
                  <i className="bx bx-baguette icon"></i>
                  Menus digitales y personalizables
                </h4>
                <h5>
                  Muestra tus platillos con estilo y actualízalos en segundos.
                </h5>
              </li>
              <li className="list-element">
                <h4 className="titleText">
                  <i className="bx bx-mobile-vibration icon"></i> Pedidos desde
                  la mesa
                </h4>
                <h5>
                  Evita filas y errores: tus clientes ordenan con su celular.
                </h5>
              </li>
              <li className="list-element">
                <h4 className="titleText">
                  <i className="bx bx-message-rounded-dots icon"></i>
                  Reseñas discretas en Tiempo Real
                </h4>
                <h5>Mejora tu atención al momento, sin exhibiciones.</h5>
              </li>
              <li className="list-element">
                <h4 className="titleText">
                  <i className="bx bx-gift icon"></i> Recompensas y fidelización
                </h4>
                <h5>Crea clientes felices que regresan más seguido.</h5>
              </li>
              <li className="list-element">
                <h4 className="titleText">
                  <i className="bx bxs-traffic icon"></i>
                  Turnos inteligentes para Food Trucks
                </h4>
                <h5>Tus clientes saben cuándo les toca, sin desorden.</h5>
              </li>
            </ul>
          </Col>
          <Col
            md={4}
            style={{
              alignItems: "center",
              alignSelf: "center",
              padding: "30px",
            }}
          >
            <Form onSubmit={submitInfo} className="formStyle">
              <h3 className="titleForm">
                ¿LISTO PARA LLEVAR TU SERVICIO AL SIGUIENTE NIVEL?
              </h3>
              <Row>
                <Col md={6}>
                  <Form.Control
                    className="controlStyle"
                    type="text"
                    placeholder="Nombre"
                  />
                </Col>
                <Col md={6}>
                  <Form.Control
                    className="controlStyle"
                    type="text"
                    placeholder="Apellidos"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Control
                    className="controlStyle"
                    type="email"
                    placeholder="Email"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Control
                    className="controlStyle"
                    type="number"
                    placeholder="Numero de contacto"
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Select
                    className="controlStyle"
                    onChange={(e) => setEstadoCode(e.target.value)}
                    placeholder="Estado"
                  >
                    <option value={""}>Estado</option>
                    {State.getStatesOfCountry("MX").map((item, index) => (
                      <option key={index} value={item.isoCode}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={6}>
                  <Form.Select className="controlStyle" placeholder="Ciudad">
                    <option value={""}>Ciudad</option>
                    {City.getCitiesOfState("MX", estadoCode).map(
                      (item, index) => (
                        <option key={index} value={item.name}>
                          {item.name}
                        </option>
                      )
                    )}
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Select
                    className="controlStyle"
                    placeholder="Tipo de negocio"
                  >
                    <option value={"truck-admin"}>Food Park</option>
                    <option value={"truck"}>Truck</option>
                    <option value={"restaurant"}>Restaurante</option>
                  </Form.Select>
                </Col>
              </Row>
              <div style={{ marginTop: 25, marginBottom: 20 }}>
                <Button text={"¡CONTACTENME!"} filled={true}></Button>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
}
